import { ConsoleOperation } from "namirasoft-core";

export class Logger
{
    log(message: string)
    {
        ConsoleOperation.log(message);
    }
    info(message: string)
    {
        ConsoleOperation.info(message);
    }
    success(message: string)
    {
        ConsoleOperation.success(message);
    }
    warning(message: string)
    {
        ConsoleOperation.warning(message);
    }
    error(message: string)
    {
        ConsoleOperation.error(message);
    }
}